/**
 * VG-WEB compatible keys — same as `VG-Web/src/variables/coreWeb.jsx`
 * so existing sessions / bookmarks still work.
 */
export const ACTIVE_ORG_STORAGE_ID = "currentOrg";
export const ACTIVE_ORG_STORAGE_NAME = "currentOrgName";

export const ACTIVE_ORG_CHANGED_EVENT = "funely:active-org-changed";

export function getActiveOrgId(): number {
  const raw = window.localStorage.getItem(ACTIVE_ORG_STORAGE_ID);
  if (raw == null || raw === "") return 0;
  const n = parseInt(raw, 10);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

export function getActiveOrgName(): string | null {
  return window.localStorage.getItem(ACTIVE_ORG_STORAGE_NAME);
}

export function setActiveOrg(orgId: number, orgName: string): void {
  window.localStorage.setItem(ACTIVE_ORG_STORAGE_ID, String(orgId));
  window.localStorage.setItem(ACTIVE_ORG_STORAGE_NAME, orgName);
  window.dispatchEvent(new Event(ACTIVE_ORG_CHANGED_EVENT));
}

export function clearActiveOrg(): void {
  window.localStorage.removeItem(ACTIVE_ORG_STORAGE_ID);
  window.localStorage.removeItem(ACTIVE_ORG_STORAGE_NAME);
  window.dispatchEvent(new Event(ACTIVE_ORG_CHANGED_EVENT));
}
